<template>
  <div class="card">
    <div class="card-body">
      <h5 class="d-flex align-items-center justify-content-between mb-0">
        <span>{{title | upperFirst}}</span>
        <small class="text-muted" v-if="data">{{total | prettyNumber}}</small>
      </h5>
      <p class="text-muted small mb-3">{{subtitle}}</p>
      <Peity
        v-if="data"
        type="line"
        :options="{ fill: '#fff', stroke: '#2CB1BC', strokeWidth: 2, width: '100%' }"
        :data="data" />
      <Loading v-else noHeadingMain :paragraphs="0" :lines="0" />
    </div>
  </div>
</template>

<script>
import Peity from 'vue-peity'
import filters from '@/mixins/filters'

export default {
  mixins: [
    filters
  ],
  components: {
    Peity
  },
  props: {
    title: String,
    subtitle: String,
    total: Number,
    data: String
  }
}
</script>
